/**
 * BDL Slideshow — altura por slide (salto na troca, sem animar opacity).
 * No mobile usa a arte mobile quando existir; no desktop, a desktop.
 *
 * Importante: em slideshow:select usar event.detail.slide — o aria-hidden do
 * slide anterior ainda pode estar "false" durante o scroll, e o querySelector
 * pegava o slide errado ao avançar (voltar funcionava por ordem no DOM).
 */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 749px)';
  var RETRY_MS = [0, 50, 120, 300, 700, 1500];

  function activeSlide(track, preferred) {
    if (preferred && preferred.tagName && track.contains(preferred)) {
      return preferred;
    }
    return (
      track.querySelector('slideshow-slide[aria-hidden="false"]') ||
      track.querySelector('slideshow-slide')
    );
  }

  function cssAspect(slide, name) {
    var raw = getComputedStyle(slide).getPropertyValue(name).trim();
    var value = parseFloat(raw);
    return value > 0 ? value : 0;
  }

  function mediaAspect(media) {
    if (!media) return 0;
    if (media.naturalWidth && media.naturalHeight) {
      return media.naturalWidth / media.naturalHeight;
    }
    if (media.videoWidth && media.videoHeight) {
      return media.videoWidth / media.videoHeight;
    }
    var w = Number(media.getAttribute('width'));
    var h = Number(media.getAttribute('height'));
    return w > 0 && h > 0 ? w / h : 0;
  }

  function visibleMedia(slide, isMobile) {
    var mobileImg = slide.querySelector('.slide__image--mobile');
    var desktopImg = slide.querySelector('.slide__image--desktop');

    if (isMobile && mobileImg) {
      var mobileDisplay = getComputedStyle(mobileImg).display;
      if (mobileDisplay !== 'none') return mobileImg;
    }

    if (desktopImg) {
      var desktopDisplay = getComputedStyle(desktopImg).display;
      if (desktopDisplay !== 'none') return desktopImg;
    }

    return mobileImg || desktopImg || slide.querySelector('img, video');
  }

  function resolveAspect(slide, isMobile) {
    var media = visibleMedia(slide, isMobile);
    var aspect = mediaAspect(media);
    if (aspect > 0) return aspect;

    // Mesmo com display:none, preferir dimensão natural da arte do breakpoint
    if (isMobile) {
      var mobileImg = slide.querySelector('.slide__image--mobile');
      aspect = mediaAspect(mobileImg);
      if (aspect > 0) return aspect;
      aspect = cssAspect(slide, '--bdl-slide-aspect-mobile');
      if (aspect > 0) return aspect;
    } else {
      var desktopImg = slide.querySelector('.slide__image--desktop');
      aspect = mediaAspect(desktopImg);
      if (aspect > 0) return aspect;
    }

    return cssAspect(slide, '--bdl-slide-aspect');
  }

  function syncHeight(section, preferredSlide) {
    var track = section.querySelector('slideshow-slides');
    var slide = track && activeSlide(track, preferredSlide);
    if (!track || !slide) return false;

    var width = track.clientWidth || section.clientWidth || window.innerWidth;
    var isMobile = window.matchMedia(MOBILE_MQ).matches;
    var aspect = resolveAspect(slide, isMobile);
    var height = 0;

    if (width > 0 && aspect > 0) {
      height = Math.round(width / aspect);
    }

    if (!(height > 0)) {
      height = Math.round(slide.getBoundingClientRect().height);
    }

    if (!(height > 0)) return false;

    track.style.setProperty('--bdl-active-slide-height', height + 'px');
    return true;
  }

  function scheduleSync(section, preferredSlide) {
    RETRY_MS.forEach(function (ms) {
      setTimeout(function () {
        syncHeight(section, preferredSlide);
      }, ms);
    });
    requestAnimationFrame(function () {
      syncHeight(section, preferredSlide);
      requestAnimationFrame(function () {
        syncHeight(section, preferredSlide);
      });
    });
  }

  function bind(section) {
    var component = section.querySelector('slideshow-component');
    if (!component || section.dataset.bdlHeightBound === 'true') return;
    section.dataset.bdlHeightBound = 'true';

    var preferredSlide = null;

    var sync = function () {
      syncHeight(section, preferredSlide);
    };

    component.addEventListener('slideshow:select', function (event) {
      preferredSlide =
        (event.detail && event.detail.slide) ||
        null;
      scheduleSync(section, preferredSlide);
    });
    window.addEventListener('resize', sync);
    if (window.matchMedia) {
      var mq = window.matchMedia(MOBILE_MQ);
      if (mq.addEventListener) mq.addEventListener('change', function () {
        scheduleSync(section, preferredSlide);
      });
      else if (mq.addListener) mq.addListener(function () {
        scheduleSync(section, preferredSlide);
      });
    }

    section.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('load', sync);
      if (img.complete && img.naturalWidth) sync();
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(sync);
      ro.observe(section);
      var track = section.querySelector('slideshow-slides');
      if (track) ro.observe(track);
    }

    scheduleSync(section, preferredSlide);
  }

  function initAll() {
    document.querySelectorAll('.bdl-slideshow').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('.bdl-slideshow') ||
        (event.target.classList && event.target.classList.contains('bdl-slideshow')
          ? event.target
          : null)
      : null;
    if (section) {
      delete section.dataset.bdlHeightBound;
      bind(section);
    }
  });
})();
